import React, { useState, useEffect } from "react";
import { createPortal } from "react-dom"; // ✅ ADD THIS
import { Link, useNavigate } from "react-router-dom";
import {
  FaSignInAlt, FaUserPlus, FaBars, FaTimes, FaHome,
  FaInfoCircle, FaUsers, FaUserPlus as FaUserPlusIcon, FaTachometerAlt
} from "react-icons/fa";
import { LogoutOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import img from "../../../Logo/logo2.jpg";
import "./HeaderSection.css";

function HeaderSection({ activeTab, setActiveTab, isLoggedIn }) {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Body scroll lock when menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const navItems = [
    { key: "home", label: "Home", icon: <FaHome /> },
    { key: "about", label: "About", icon: <FaInfoCircle /> },
    { key: "success", label: "Successful Couples", icon: <FaUsers /> },
    { key: "signup", label: "Sign up", icon: <FaUserPlusIcon /> },
  ];
  const handleDashboard = () => {
    setIsMobileMenuOpen(false);
    navigate("/dashboard");
  };
  const handleLogout = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You want to logout?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#ff0044',
      cancelButtonColor: '#999',
      confirmButtonText: 'Yes, logout!'
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem('user_id');
        localStorage.removeItem('user_role');
        localStorage.removeItem('user_token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('user_gender');
        localStorage.removeItem('user_caste');
        navigate('/User_Login');
        Swal.fire({
          title: 'Logged Out!',
          text: 'You have been successfully logged out.',
          icon: 'success',
          timer: 1500,
          showConfirmButton: false
        });
      }
    });
  };

  const handleNavClick = (item) => {
    setActiveTab(item.key);
    setIsMobileMenuOpen(false);

    if (item.key === "home") {
      document.getElementById("hero")?.scrollIntoView({ behavior: "smooth" });
    }
    if (item.key === "about") {
      document.getElementById("about-section")?.scrollIntoView({ behavior: "smooth" });
    }
    if (item.key === "success") {
      document.getElementById("success-section")?.scrollIntoView({ behavior: "smooth" });
    }
    if (item.key === "signup") {
      navigate('/User_Reg');
    }
  };

  // ✅ Mobile Menu Portal Content
  const mobileMenuPortal = createPortal(
    <>
      {/* Overlay */}
      <div
        className={`mobile-overlay ${isMobileMenuOpen ? "active" : ""}`}
        onClick={() => setIsMobileMenuOpen(false)}
      />

      {/* Sidebar Menu */}
      <div className={`mobile-menu-luxury ${isMobileMenuOpen ? "open" : ""}`}>
        <div className="mobile-menu-header">
          <div className="mobile-logo">
            <img src={img} alt="Logo" className="mobile-logo-img" />
            <span>Community Rishtey</span>
          </div>
          <button
            className="mobile-close-btn"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <FaTimes />
          </button>
        </div>

        <div className="mobile-menu-content">
          <ul className="mobile-nav-list-luxury">
            {navItems.map((item) => (
              <li key={item.key}>
                <button
                  className={`mobile-nav-link-luxury ${activeTab === item.key ? "active" : ""}`}
                  onClick={() => handleNavClick(item)}
                >
                  <span className="mobile-nav-icon">{item.icon}</span>
                  <span className="mobile-nav-text">{item.label}</span>
                  {activeTab === item.key && (
                    <span className="mobile-nav-indicator"></span>
                  )}
                </button>
              </li>
            ))}

            <li className="mobile-divider"></li>

            {isLoggedIn && (
              <>
                <li>
                  <button
                    className="mobile-nav-link-luxury dashboard-mobile"
                    onClick={handleDashboard}
                  >
                    <FaTachometerAlt className="mobile-nav-icon" />
                    <span className="mobile-nav-text">My Dashboard</span>
                  </button>
                </li>

                <li>
                  <button
                    className="mobile-nav-link-luxury logout-mobile"
                    onClick={handleLogout}
                  >
                    <LogoutOutlined className="mobile-nav-icon" />
                    <span className="mobile-nav-text">Logout</span>
                  </button>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </>,
    document.body // ✅ body me directly render hoga
  );

  return (
    <>
      <header className="header-luxury">
        <div className="header-container-luxury">

          {/* Logo */}
          <div className="header-logo-luxury">
            <Link to="/" className="logo-link-luxury">
              <div className="logo-icon-luxury">
                <img src={img} alt="Logo" className="logo-heart-icon" />
              </div>
              <div className="logo-text-luxury">
                <span className="logo-main">Community</span>
                <span className="logo-highlight">Rishtey</span>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="header-nav-luxury">
            <ul className="nav-list-luxury">
              {navItems.map((item) => (
                <li key={item.key} className="nav-item-luxury">
                  <button
                    className={`nav-link-luxury ${activeTab === item.key ? "active" : ""}`}
                    onClick={() => handleNavClick(item)}
                  >
                    <span className="nav-label">{item.label}</span>
                    {activeTab === item.key && (
                      <span className="nav-indicator"></span>
                    )}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Right Section */}
          <div className="header-right-luxury">
            {/* {!isLoggedIn && (
              <div className="desktop-auth-buttons">
                <Link to="/User_Login" className="auth-btn login-btn">
                  <FaSignInAlt /> Sign In
                </Link>
                <Link to="/User_Reg" className="auth-btn signup-btn">
                  <FaUserPlus /> Sign Up
                </Link>
              </div>
            )} */}
           {isLoggedIn && (
  <div className="desktop-user-actions">
    <button className="dashboard-btn-desktop" onClick={handleDashboard}>
      <FaTachometerAlt /> My Dashboard
    </button>
    <button className="logout-btn-desktop" onClick={handleLogout}>
      <LogoutOutlined /> Logout
    </button>
  </div>
)}
            {/* ✅ Toggle Button */}
            <button
              className="mobile-toggle-luxury"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
            </button>
          </div>

        </div>
      </header>

      {/* ✅ Portal - body me render hoga, header ke bahar */}
      {mobileMenuPortal}
    </>
  );
}

export default HeaderSection;